<template>
  <ServicePageLayout
    title="Fire Alarm"
    subtitle="ระบบแจ้งเตือนเหตุเพลิงไหม้"
    icon="mdi-fire"
    icon-color="error"
    breadcrumb="Operations"
    :available="assets.length > 0"
  >
    <v-tabs v-model="tab" class="industrial-tabs">
      <v-tab>Dashboard</v-tab>
      <v-tab>Status</v-tab>
      <v-tab>Analytic</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><Dashboard /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><Status /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><Analytic /></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import Dashboard from '@/components/firealarm_system/fire_alarm_dashboard.vue'
import Status from '@/components/firealarm_system/fire_alarm_status.vue'
import Analytic from '@/components/firealarm_system/fire_alarm_analytics.vue'

export default {
  name: 'FireAlarmView',
  components: {
    ServicePageLayout,
    Status,
    Dashboard,
    Analytic,
  },
  computed: {
    assets() {
      return this.$store.state.Asset.assetFireAlarm
    }
  },
  data() {
    return { tab: null }
  },
}
</script>
